import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom"; // or your router equivalent
import ReportListSelector from "./ReportListSelector";
import MonthlyReportModal from "../../../../components/ui/popup/finances/MonthlyReportModal";

function Reports({ content, isPaidPlan, onUpgradeClick }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedSnapshotUuid, setSelectedSnapshotUuid] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Auto-open modal if URL has snapshot query parameter from email/notification link
  useEffect(() => {
    const type = searchParams.get("type");
    const snapshotUuid = searchParams.get("snapshot");

    if (type === "report" && snapshotUuid) {
      setSelectedSnapshotUuid(snapshotUuid);
      setIsModalOpen(true);
    }
  }, [searchParams]);

  const handleOpenReport = (snapshotUuid) => {
    setSelectedSnapshotUuid(snapshotUuid);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSnapshotUuid(null);
    // Clean up query params from URL on close so refresh doesn't force re-opening
    setSearchParams((params) => {
      params.delete("type");
      params.delete("snapshot");
      return params;
    });
  };

  return (
    <div className="money-guardian-dashboard-wrapper">
      <ReportListSelector content={content} onViewReport={handleOpenReport} />

      {isModalOpen && (
        <MonthlyReportModal
          snapshotUuid={selectedSnapshotUuid}
          content={content}
          isPaidPlan={isPaidPlan}
          onClose={handleCloseModal}
          onUpgradeClick={onUpgradeClick}
        />
      )}
    </div>
  );
}

export default Reports;
